/**
 * Reading the flow of gold (ADR 0038). Every move of gold is a line of the
 * ledger with a reason and a signed delta; this sums them so an admin sees
 * what creates gold, what destroys it, and what only moves it between
 * players. The rates themselves live with their feature (`rules/auction.ts`,
 * `rules/guild.ts`).
 */
/**
 * Reasons whose lines come in pairs, one player's loss another's gain: not
 * minted, not burnt, except the auction's fee, which is the difference
 * between what the buyer paid and what the seller received.
 */
export const GOLD_TRANSFER_REASONS = [
    'trade_gold',
    'auction_pay',
    'auction_sale',
];
export function summariseGoldFlow(lines) {
    const minted = {};
    const burnt = {};
    const transferred = {};
    let paid = 0;
    let received = 0;
    for (const line of lines) {
        if (line.delta === 0)
            continue;
        if (GOLD_TRANSFER_REASONS.includes(line.reason)) {
            if (line.reason === 'auction_pay')
                paid += -line.delta;
            else if (line.reason === 'auction_sale')
                received += line.delta;
            else if (line.delta < 0)
                transferred[line.reason] = (transferred[line.reason] ?? 0) - line.delta;
            continue;
        }
        const bucket = line.delta > 0 ? minted : burnt;
        bucket[line.reason] = (bucket[line.reason] ?? 0) + Math.abs(line.delta);
    }
    if (paid > 0 || received > 0) {
        transferred.auction = received;
        if (paid - received > 0)
            burnt.auction_fee = paid - received;
    }
    const sum = (bucket) => Object.values(bucket).reduce((total, value) => total + value, 0);
    return { minted, burnt, transferred, net: sum(minted) - sum(burnt) };
}
//# sourceMappingURL=economy.js.map